export enum PermissionsEnum {
    CrmAllAll = 'crm:all:all',

    /**
     * Clients
     */
    CrmClientsAll = 'crm:clients:all',
    CrmClientsCreateNew = 'crm:clients:create-new',
    CrmClientsViewDetails = 'crm:clients:view-details',
    CrmClientsUpdateDetails = 'crm:clients:update-details',
    CrmClientsDelete = 'crm:clients:delete',
    CrmClientsViewStatus = 'crm:clients:view-status',
    CrmClientsUpdateStatus = 'crm:clients:update-status',
    CrmClientsViewCashAndEquity = 'crm:clients:view-cash-and-equity',
    CrmClientsViewRiskParameters = 'crm:clients:view-risk-parameters',
    CrmClientsUpdateRiskParameters = 'crm:clients:update-risk-parameters',
    CrmClientsUpdateRiskScore = 'crm:clients:update-risk-score',
    CrmClientsExport = 'crm:clients:export',

    /**
     * Client users
     */
    CrmUsersAll = 'crm:users:all',
    CrmUsersCreateNew = 'crm:users:create-new',
    CrmUsersViewDetails = 'crm:users:view-details',
    CrmUsersDelete = 'crm:users:delete',
    CrmUsersViewStatus = 'crm:users:view-status',
    CrmUsersUpdateStatus = 'crm:users:update-status',
    CrmUsersViewRights = 'crm:users:view-rights',
    CrmUsersUpdateRights = 'crm:users:update-rights',
    CrmUsersDeleteDetails = 'crm:users:delete-details',
    CrmUsersUpdateDetails = 'crm:users:update-details',

    /**
     * Subscription management
     */
    CrmSubscriptionManagementAll = 'crm:subscription-management:all',
    CrmSubscriptionManagementViewAvailableFeeds = 'crm:subscription-management:view-available-feeds',
    CrmSubscriptionManagementManageFeeds = 'crm:subscription-management:manage-feeds',
    CrmSubscriptionManagementViewFeedPrice = 'crm:subscription-management:view-feed-price',
    CrmSubscriptionManagementManageFeedBundles = 'crm:subscription-management:manage-feed-bundles',
    CrmSubscriptionManagementSetUserSettings = 'crm:subscription-management:set-user-settings',
    CrmSubscriptionManagementViewUserSettings = 'crm:subscription-management:view-user-settings',
    CrmSubscriptionManagementViewSubscriptionPrice = 'crm:subscription-management:view-subscription-price',
    CrmSubscriptionManagementSetSubscriptionPrice = 'crm:subscription-management:set-subscription-price',
    CrmSubscriptionManagementAssignFeedsToUsers = 'crm:subscription-management:assign-feeds-to-users',
    CrmSubscriptionManagementViewAssignedFeeds = 'crm:subscription-management:view-assigned-feeds',
    CrmSubscriptionManagementEditAssignedFeeds = 'crm:subscription-management:edit-assigned-feeds',
    CrmSubscriptionManagementViewMarkups = 'crm:subscription-management:view-markups',
    CrmSubscriptionManagementSetMarkups = 'crm:subscription-management:set-markups',
    CrmSubscriptionManagementViewEventHistory = 'crm:subscription-management:view-event-history',
    CrmSubscriptionManagementManageTradingPlatforms = 'crm:subscription-management:manage-trading-platforms',
    CrmSubscriptionManagementViewEntitlementReports = 'crm:subscription-management:view-entitlement-reports',
    CrmSubscriptionManagementViewMarketDataUsageReports = 'crm:subscription-management:view-market-data-usage-reports',
    CrmSubscriptionManagementManageUserMarkups = 'crm:subscription-management:manage-user-markups',

    /**
     * Documents
     */
    CrmDocumentsAll = 'crm:documents:all',
    CrmDocumentsCreateNew = 'crm:documents:create-new',
    CrmDocumentsViewDetails = 'crm:documents:view-details',
    CrmDocumentsUpdateDetails = 'crm:documents:update-details',
    CrmDocumentsDownloadPreview = 'crm:documents:download/preview',

    /**
     * Cash accounts
     */
    CrmCashAccountsAll = 'crm:cash-accounts:all',
    CrmCashAccountsCreateNew = 'crm:cash-accounts:create-new',
    CrmCashAccountsViewDetails = 'crm:cash-accounts:view-details',
    CrmCashAccountsUpdateDetails = 'crm:cash-accounts:update-details',
    CrmCashAccountsDelete = 'crm:cash-accounts:delete',
    CrmCashAccountsViewBalance = 'crm:cash-accounts:view-balance',
    CrmCashAccountsUpdateStatus = 'crm:cash-accounts:update-status',
    CrmCashAccountsViewFeePlans = 'crm:cash-accounts:view-fee-plans',
    CrmCashAccountsAddFeePlans = 'crm:cash-accounts:add-fee-plans',
    CrmCashAccountsUpdateFeePlans = 'crm:cash-accounts:update-fee-plans',
    CrmCashAccountsDeleteFeePlans = 'crm:cash-accounts:delete-fee-plans',
    CrmCashAccountsExport = 'crm:cash-accounts:export',


    /**
     * Trading accounts
     */
    CrmTradingAccountsAll = 'crm:trading-accounts:all',
    CrmTradingAccountsCreateNew = 'crm:trading-accounts:create-new',
    CrmTradingAccountsViewDetails = 'crm:trading-accounts:view-details',
    CrmTradingAccountsUpdateDetails = 'crm:trading-accounts:update-details',
    CrmTradingAccountsDelete = 'crm:trading-accounts:delete',
    CrmTradingAccountsUpdateStatus = 'crm:trading-accounts:update-status',
    CrmTradingAccountsAddFeePlans = 'crm:trading-accounts:add-fee-plans',
    CrmTradingAccountsViewFeePlans = 'crm:trading-accounts:view-fee-plans',
    CrmTradingAccountsUpdateFeePlans = 'crm:trading-accounts:update-fee-plans',
    CrmTradingAccountsDeleteFeePlans = 'crm:trading-accounts:delete-fee-plans',
    CrmTradingAccountsViewCurrentPositions = 'crm:trading-accounts:view-current-positions',
    CrmTradingAccountsDeleteSubscription = 'crm:trading-accounts:delete-subscription',
    CrmTradingAccountsExport = 'crm:trading-accounts:export',

    /**
     * Bank accounts
     */
    CrmBankAccountsAll = 'crm:bank-accounts:all',
    CrmBankAccountsCreateNew = 'crm:bank-accounts:create-new',
    CrmBankAccountsViewDetails = 'crm:bank-accounts:view-details',
    CrmBankAccountsUpdateDetails = 'crm:bank-accounts:update-details',
    CrmBankAccountsDelete = 'crm:bank-accounts:delete',

    /**
     * Payments
     */
    CrmPaymentsAll = 'crm:payments:all',
    CrmPaymentsCreateNewDeposit = 'crm:payments:create-new-deposit',
    CrmPaymentsCreateNewWithdrawal = 'crm:payments:create-new-withdrawal',
    CrmPaymentsCreateNewAdjustment = 'crm:payments:create-new-adjustment',
    CrmPaymentsCreateNewTransfer = 'crm:payments:create-new-transfer',
    CrmPaymentsViewDetails = 'crm:payments:view-details',
    CrmPaymentsUpdateDetails = 'crm:payments:update-details',
    CrmPaymentsDelete = 'crm:payments:delete',

    /**
     * Reports
     */
    CrmReportsAll = 'crm:reports:all',
    CrmReportsViewPredefinedReports = 'crm:reports:view-predefined-reports',
    CrmReportsViewCustomReports = 'crm:reports:view-custom-reports',
    CrmReportsViewStatements = 'crm:reports:view-statements',
    CrmReportsAssignReportTypesToClientUsers = 'crm:reports:assign-report-types-to-client-users',
    CrmReportsCreateCustomReports = 'crm:reports:create-custom-reports',
    CRMReportsViewMarketingReports = 'crm:reports:view-marketing-reports',
    CRMReportsManageMarketingReports = 'crm:reports:manage-marketing-reports',
    /**
     * Audit trail
     */
    CrmAuditTrailAll = 'crm:audit-trail:all',
    CrmAuditTrailView = 'crm:audit-trail:view',

    /**
     * Zendesk
     */
    CrmZendeskActivitiesAll = 'crm:zendesk-activities:all',
    CrmZendeskActivitiesCreateNew = 'crm:zendesk-activities:create-new',
    CrmZendeskActivitiesViewDetails = 'crm:zendesk-activities:view-details',
    CrmZendeskActivitiesUpdate = 'crm:zendesk-activities:update',
    CrmZendeskActivitiesDelete = 'crm:zendesk-activities:delete',

    /**
     * Operators and roles
     */
    CrmOperatorsAndRolesAll = 'crm:operators-and-roles:all',
    CrmOperatorsAndRolesCreateNewRole = 'crm:operators-and-roles:create-new-role',
    CrmOperatorsAndRolesViewUsersRoles = 'crm:operators-and-roles:view-user\'s-roles',
    CrmOperatorsAndRolesUpdateRole = 'crm:operators-and-roles:update-role',
    CrmOperatorsAndRolesDeleteRole = 'crm:operators-and-roles:delete-role',
    CrmOperatorsAndRolesViewUser = 'crm:operators-and-roles:view-user',
    CrmOperatorsAndRolesCreateNewOperator = 'crm:operators-and-roles:create-new-operator',
    CrmOperatorsAndRolesUpdateOperator = 'crm:operators-and-roles:update-operator',
    CrmOperatorsAndRolesDeleteUser = 'crm:operators-and-roles:delete-user',

    /**
     * Client groups
     */
    CrmClientGroupsAll = 'crm:client-groups:all',
    CrmClientGroupsCreateNewGroup = 'crm:client-groups:create-new-group',
    CrmClientGroupsViewClientGroups = 'crm:client-groups:view-client-groups',
    CrmClientGroupsUpdateGroup = 'crm:client-groups:update-group',
    CrmClientGroupsDeleteGroup = 'crm:client-groups:delete-group',

    /**
     * System settings
     */
    CrmSystemSettingsAll = 'crm:system-settings:all',
    CrmSystemSettingsViewDetails = 'crm:system-settings:view-details',
    CrmSystemSettingsUpdate = 'crm:system-settings:update',

    /**
     * Business
     */
    CrmBusinessAll = 'crm:business:all',
    CrmBusinessCreate = 'crm:business:create',
    CrmBusinessView = 'crm:business:view',
    CrmBusinessUpdate = 'crm:business:update',
    CrmBusinessDelete = 'crm:business:delete',

    /**
     * Messaging System
     */
    // EmailTemplates
    AmsEmailTemplatesView = 'ams:email-templates:view',
    AmsEmailTemplatesEdit = 'ams:email-templates:edit',
    AmsEmailTemplatesCreate = 'ams:email-templates:create',
    AmsEmailTemplatesApprove = 'ams:email-templates:approve',

    // MessageTemplates
    AmsMessageTemplatesView = 'ams:message-templates:view',
    AmsMessageTemplatesEdit = 'ams:message-templates:edit',
    AmsMessageTemplatesCreate = 'ams:message-templates:create',
    AmsMessageTemplatesApprove = 'ams:message-templates:approve',

    AmsMessagesView = 'ams:messages:view',

    // TemplateMessages
    AmsMessagesEditWithTemplate = 'ams:messages:edit-with-template',
    AmsMessagesCreateWithTemplate = 'ams:messages:create-with-template',
    AmsMessagesSendWithTemplate = 'ams:messages:send-with-template',

    // ManualMessages
    AmsMessagesEditManual = 'ams:messages:edit-manual',
    AmsMessagesCreateManual = 'ams:messages:create-manual',
    AmsMessagesSendManual = 'ams:messages:send-manual',

    /**
     * File Import
     */
    CrmFileImportAll = 'crm:file-import:all',
    CrmFileImportClientsAndAccounts = 'crm:file-import:clients-and-accounts',

    /**
     * Fund Portal
     */
    FundPortalAccountsManageAccounts = 'fund-portal:accounts:manage-accounts',
    CrmFundOrdersAll = 'crm:fund-orders:all',
    CrmFundOrdersCreate = 'crm:fund-orders:create-order',
    CrmFundOrdersUpdate = 'crm:fund-orders:update-order',
    CrmFundOrdersView = 'crm:fund-orders:view-order',
    CrmFundOUploadPosition = 'crm:fund-orders:upload-position',
    CrmFundExecutionsCreate = 'crm:fund-orders:create-execution',
    CrmFundExecutionsUpdate = 'crm:fund-orders:update-execution',
    CrmFundExecutionsView = 'crm:fund-orders:view-execution',
    CrmFundProductsAll = 'crm:fund-products:all',
    CrmFundProductsViewProduct = 'crm:fund-products:view-product',
    CrmFundProductsCreateProduct = 'crm:fund-products:create-product',
    CrmFundProductsUpdateProduct = 'crm:fund-products:update-product',
    CrmFundProductsManagePrices = 'crm:fund-products:manage-prices',

    /**
     * Administration
     */
    CRMAdministrationSuperAdmin = 'crm:administration:super-admin',


    /**
    * TradingPlans
    */
    CrmTradingPlansAll = "crm:trading-plans:all",
    CrmTradingPlansView = "crm:trading-plans:view",
    CrmTradingPlansCreate = "crm:trading-plans:create",
    CrmTradingPlansUpdate = "crm:trading-plans:update",
    CrmTradingPlansDelete = "crm:trading-plans:delete",

    /**
     * OrderRoutes
     */
    CrmOrderRoutesAll = 'crm:order-routes:all',
    CrmOrderRoutesView = 'crm:order-routes:view',
    CrmOrderRoutesCreate = 'crm:order-routes:create',
    CrmOrderRoutesUpdate = 'crm:order-routes:update',
    CrmOrderRoutesDelete = 'crm:order-routes:delete',

    /**
     * Coupons
     */
    CrmCouponsAll = 'crm:coupons:all',
    CrmCouponsView = 'crm:coupons:view',
    CrmCouponsCreate = 'crm:coupons:create',
    CrmCouponsEdit = 'crm:coupons:edit',
    CrmCouponsChangeStatus = 'crm:coupons:change-status',
    CrmCouponsExport = 'crm:coupons:export',
    CrmCouponsViewAudit = 'crm:coupons:view-audit',

    /**
     * Bond Coupons. A separate family from the crm:coupons:* block above, which is the
     * discount and promo-code domain - do not extend that group. Manage covers entering the
     * receipt and calculating; Execute covers starting a distribution and retrying failed rows.
     */
    CrmBondCouponsManageDistribution = 'crm:bond-coupons:manage-distribution',
    CrmBondCouponsExecuteDistribution = 'crm:bond-coupons:execute-distribution',

    /**
     * Closeout Plans
     */
    CrmCloseoutPlansAll = 'crm:closeout-plans:all',
    CrmCloseoutPlansView = 'crm:closeout-plans:view',
    CrmCloseoutPlansCreate = 'crm:closeout-plans:create',
    CrmCloseoutPlansEdit = 'crm:closeout-plans:edit',
    CrmCloseoutPlansChangeStatus = 'crm:closeout-plans:change-status',

    /**
     * Hard buying power (CRM-5445): one right for group ceilings, group thresholds and account hard BP.
     */
    CrmHardBuyingPowerManage = 'crm:hard-buying-power:manage',


}
